import { TarifariosComponent } from './../../tarifarios/tarifarios.component';
import { BreadcrumbComponent } from './../../breadcrumb/breadcrumb.component';
import {
	Component,
	HostListener,
	inject,
	OnDestroy,
	OnInit
} from '@angular/core';
import { filter } from 'rxjs/operators';
import { HeaderSideComponent } from '../../header-side/header-side.component';
import { HeaderTopComponent } from './../../header-top/header-top.component';
import { SidebarSideComponent } from '../../sidebar-side/sidebar-side.component';
import { SidebarTopComponent } from '../../sidebar-top/sidebar-top.component';
import { LayoutService } from '../../../services/layout.service';
import { MainProductServices } from './../../../services/main-product.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import {
	NavigationEnd,
	ResolveEnd,
	ResolveStart,
	RouteConfigLoadEnd,
	RouteConfigLoadStart,
	Router,
	RouterModule
} from '@angular/router';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';
import { ThemeService } from '../../../services/theme.service';

@Component({
	selector: 'app-admin-layout',
	templateUrl: './admin-layout.template.html',
	standalone: true,
	imports: [
		BreadcrumbComponent,
		HeaderSideComponent,
		HeaderTopComponent,
		MatSidenavModule,
		NgClass,
		RouterModule,
		SidebarSideComponent,
		SidebarTopComponent,
		TarifariosComponent
	]
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
	private router = inject(Router);
	themeService = inject(ThemeService);
	private layout = inject(LayoutService);
	private typeService = inject(MainProductServices);

	public isModuleLoading: Boolean = false;
	private moduleLoaderSub: Subscription;
	private layoutConfSub: Subscription;
	private routerEventSub: Subscription;
	public scrollConfig = {};
	public layoutConf: any = {};
	titleMenu: string = 'Menú';

	constructor() {
		const router = this.router;

		// Close sidenav after route change in mobile
		this.routerEventSub = router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange: NavigationEnd) => {
			this.layout.adjustLayout({ route: routeChange.url });
		});
	}

	ngOnInit() {
		this.layoutConf = this.layout.layoutConf;
		// FOR MODULE LOADER FLAG
		// this.typeService.saveMainProduct("SOAT");
		this.moduleLoaderSub = this.router.events.subscribe(event => {
			if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
				this.isModuleLoading = true;
			}
			if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
				this.isModuleLoading = false;
			}
		});
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.layout.adjustLayout(event);
	}

	scrollToTop(selector: string) {
		if (document) {
			const element = <HTMLElement>document.querySelector(selector);
			element.scrollTop = 0;
		}
	}

	ngOnDestroy() {
		if (this.moduleLoaderSub) {
			this.moduleLoaderSub.unsubscribe();
		}
		if (this.layoutConfSub) {
			this.layoutConfSub.unsubscribe();
		}
		if (this.routerEventSub) {
			this.routerEventSub.unsubscribe();
		}
	}

	closeSidebar() {
		this.layout.publishLayoutChange({
			sidebarStyle: 'closed'
		});
	}
}
